<template>
  <v-container
    fluid
    class="mt-12 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-row>
      <v-col
        v-for="product in products"
        :key="product.id"
        :class="'col-12 col-xs-12 col-md-6 col-sm-12 col-lg-4'"
      >
        <v-card
          class="mx-auto"
          max-width="100%"
          @click="openProduct(product.id)"
          dark
        >
          <v-img
            :src="`/api/products/image?id=${product.id}`"
            height="100%"
          ></v-img>

          <v-card-title>
            <span class="text-subtitle-2">{{ product.name }}</span
            >&nbsp;<span
              v-if="!product.in_stock"
              class="text-subtitle-2"
              :style="'color: #fd5454 !important;'"
              >Niedostępny</span
            >
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-if="currentProduct"
      v-model="productDialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      hide-overlay
      dark
      width="800"
      :transition="
        this.$vuetify.breakpoint.mobile
          ? 'slide-x-transition'
          : 'dialog-bottom-transition'
      "
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="productDialog = false">
            <v-icon :style="'color: white;'">{{
              this.$vuetify.breakpoint.mobile
                ? "fas fa-chevron-left"
                : "fas fa-times"
            }}</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color: white;'"
            >{{ currentProduct.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid class="p-1">
          <v-row class="d-flex justify-center">
            <v-col cols="12" sm="8" lg="7" md="7" class="d-flex justify-center">
              <v-img
                :src="`/api/products/image?id=${currentProduct.id}`"
                elevation="1"
                class="rounded thumbnail-static"
              >
              </v-img>
            </v-col>
            <v-col cols="12" sm="4" lg="5" md="5">
              <v-row v-if="currentProduct.in_stock">
                <v-col cols="12">
                  <v-select
                    :items="currentProduct.variants"
                    v-model="selectedVariant"
                    label="Wybierz ilość"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0">
                  <span class="text-h5"
                    >Cena:
                    <span v-if="$store.state.globalDiscount>0">
                      <del>{{
                      currentProduct.variants.find(
                        (v) => v.value == selectedVariant
                      ).price
                    }}{{ $store.state.currency }}</del>
                      
                    </span>
                    <span v-else>
                      {{
                      currentProduct.variants.find(
                        (v) => v.value == selectedVariant
                      ).price
                    }}{{ $store.state.currency }}
                    </span>
                    <span v-if="$store.state.globalDiscount>0" :style="'color:#0d0;'">
                      {{
                      parseInt(
                    (currentProduct.variants.find(
                        (v) => v.value == selectedVariant
                      ).price) *
                      ((100 - $store.state.globalDiscount) / 100)
                  )
                    }}{{ $store.state.currency }}
                    </span>
                    </span
                  >
                </v-col>

                <v-col cols="12" v-show="false">
                  <span v-if="$store.state.globalDiscount>0" :style="'color:#0d0;'">
                      {{
                      parseInt(
                    (currentProduct.variants.find(
                        (v) => v.value == selectedVariant
                      ).price) *
                      ((100 - $store.state.globalDiscount) / 100)
                  )
                    }}{{ $store.state.currency }}/1g
                    </span>
                </v-col>
                
                <v-col cols="12" primary v-if="!$store.getters.productInCart(currentProduct.id)">
                  <v-btn
                    block
                    light
                    :loading="cartLoading"
                    @click="addToCart()"
                    ><v-icon>fas fa-cart-plus</v-icon>&nbsp;Dodaj do
                    koszyka</v-btn
                  >
                  
                </v-col>
                <v-col v-else>
                  <v-btn
                    block
                    light
                    @click="deleteFromCart()"
                    :loading="cartLoading"
                    ><v-icon>fas fa-trash-alt</v-icon>&nbsp;Usuń z
                    koszyka</v-btn>
                    <span class="text-center">Dodano: {{$store.getters.productInCart(currentProduct.id).label}} </span>
                </v-col>
                
                <v-col cols="12" primary>
                  <v-divider class="mt-2 mb-2"></v-divider>
                  <v-btn
                    block
                    @click="goToCart()"
                    ><v-icon>fas fa-shopping-basket</v-icon>&nbsp;Przejdź do koszyka <span v-if="$store.getters.cartSize>0">({{$store.getters.cartSize}})</span></v-btn
                  >
                  <v-btn
                  class="mt-2"
                  v-if="$store.getters.cartSize>0"
                    block
                    @click="goToOrder()"
                    ><v-icon :style="'color: green;'">fas fa-store</v-icon>&nbsp;Przejdź do zamówienia</v-btn
                  >
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" class="text-center">
                  <span :style="'color: #fd5454 !important;'"
                    >Produkt chwilowo niedostępny</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mt-2 mb-2"></v-divider>
          <v-row>
            <v-col cols="12" v-if="currentProduct.links && currentProduct.links.length > 0">
              <v-btn v-for="link in currentProduct.links" :key="link.url" light class="ml-2 mt-1">
                <a :href="link.url" target="_blank" rel="noreferrer noopener">
                  {{ link.label }}
                </a>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <span
                v-html="currentProduct.description.replaceAll('\n', '<br>')"
              ></span>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "ProductsView",
  data: () => ({
    cartLoading: false,
    products: [],
    productDialog: false,
    currentProduct: false,
    selectedVariant: false,
  }),
  methods: {
    openProduct: function (id) {
      this.currentProduct = this.products.find((p) => p.id == id);
      this.selectedVariant = this.currentProduct.variants[0].value;
      this.productDialog = true;
    },
    goToCart: function(){
      this.$router.push('/koszyk');
    },
    goToOrder: function(){
      this.$router.push('/zamowienie');
    },
    addToCart: function () {
      this.cartLoading = true;
      this.$axios
        .post("/api/cart/add", {
          id: this.currentProduct.id,
          vid: this.selectedVariant,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.$store.commit("setCart", response.data.cart);
            this.cartLoading = false;
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas dodawania produktu!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.cartLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas dodawania produktu!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.cartLoading = false;
          console.log(error);
        });
    },
    deleteFromCart: function () {
      this.cartLoading = true;
      this.$axios
        .post("/api/cart/delete", {
          id: this.currentProduct.id,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.$store.commit("setCart", response.data.cart);
            this.cartLoading = false;
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas usuwania produktu!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.cartLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas usuwania produktu!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.cartLoading = false;
          console.log(error);
        });
    },
  },
  created: function () {
    this.$axios
      .get("/api/products/getall")
      .then(async (response) => {
        if (response.data.success) {
          this.products = response.data.products;
        } else {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas ładowania produktów!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.products = response.data.products;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  components: {},
};
</script>
